import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceRequirement} from './service-requirement.model';
import * as ServiceRequirementActions from './service-requirement.actions';

export const serviceRequirementsFeatureKey = 'serviceRequirements';

export interface State extends EntityState<ServiceRequirement> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceRequirement> = createEntityAdapter<ServiceRequirement>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceRequirementActions.addServiceRequirement,
    (state, action) => adapter.addOne(action.serviceRequirement, state)
  ),
  on(ServiceRequirementActions.upsertServiceRequirement,
    (state, action) => adapter.upsertOne(action.serviceRequirement, state)
  ),
  on(ServiceRequirementActions.addServiceRequirements,
    (state, action) => adapter.addMany(action.serviceRequirements, state)
  ),
  on(ServiceRequirementActions.upsertServiceRequirements,
    (state, action) => adapter.upsertMany(action.serviceRequirements, state)
  ),
  on(ServiceRequirementActions.updateServiceRequirement,
    (state, action) => adapter.updateOne(action.serviceRequirement, state)
  ),
  on(ServiceRequirementActions.updateServiceRequirements,
    (state, action) => adapter.updateMany(action.serviceRequirements, state)
  ),
  on(ServiceRequirementActions.deleteServiceRequirement,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceRequirementActions.deleteServiceRequirements,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceRequirementActions.loadServiceRequirements,
    (state, action) => adapter.setAll(action.serviceRequirements, state)
  ),
  on(ServiceRequirementActions.clearServiceRequirements,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
